import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import filterStore from '../filter.store';
import FloorPopup from '../FloorPopup/FloorPopup';
import { TFilterItem } from '../../../modules/copia/copia.type';
import { CustomFilterBodyProps } from '../customFilter.type';
import FromTo from '../fromTo/FromTo';

const FloorBody: React.FC<CustomFilterBodyProps> = observer(
  ({ childs, handleChange, category, item }) => {
    const { queryParams, openCategoryChild } = filterStore;
    const [data, setData] = useState<any>(
      childs.map((child: any) => ({
        ...child,
        value: queryParams[child.key],
      })),
    );

    const handleInputChange = (item: TFilterItem, value: string, i: number) => {
      const res = data;
      res[i] = {
        ...res[i],
        value,
      };
      setData([...res]);
    };
    return (
      <FloorPopup
        isSingle={!!item.isSingle}
        onCancel={() => item.onCancel()}
        onSelect={() => {
          item.onConfirm(data);
        }}
      >
        <FromTo
          childs={data}
          handleChange={(e: any, index: any) =>
            handleInputChange(item, e.target.value, index)
          }
        />
      </FloorPopup>
    );
  },
);

export default FloorBody;
